export interface StoreRanking {
  store_code: number;
  rank: number;
}

const cleanSorting = (input: StoreRanking[]): StoreRanking[] => {
  if (input.length) {
    input.sort((a, b) => a.rank - b.rank);
    return input.map((item, index) => ({ ...item, rank: index + 1 }));
  }

  return input;
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const changeToNewRanking = (stores: StoreRanking[] | undefined, store_code: number, targetInput: string) => {
  if (stores) {
    const storeList = cleanSorting(stores);
    const target = parseInt(targetInput) > storeList.length ? storeList.length : parseInt(targetInput);
    const origItemIndex = storeList.findIndex((item) => {
      return item.store_code === store_code;
    });
    const targetItemIndex = storeList.findIndex((item) => {
      return item.rank === target;
    });

    if (origItemIndex > targetItemIndex) {
      for (let i = origItemIndex - 1; i > targetItemIndex - 1; i--) {
        storeList[i].rank++;
      }
    } else {
      for (let i = origItemIndex + 1; i < targetItemIndex + 1; i++) {
        storeList[i].rank--;
      }
    }

    storeList[origItemIndex].rank = target;

    storeList.sort((a, b) => {
      return a.rank - b.rank;
    });

    return storeList;
  }

  return stores;
};

const findRankingChangedStores = (originalList: StoreRanking[], changedList: StoreRanking[]): StoreRanking[] => {
  const differentStores = [];

  for (let i = 0; i < originalList.length; i++) {
    const changedProduct = findStoreByStoreCode(changedList, originalList[i].store_code);

    if (originalList[i].rank !== changedProduct?.rank) {
      if (changedProduct) {
        differentStores.push(changedProduct);
      }
    }
  }

  return differentStores;
};

const findStoreByStoreCode = (list: StoreRanking[], id: number) => {
  return list.find((item: StoreRanking) => {
    return item.store_code === id;
  });
};

export { cleanSorting, changeToNewRanking, findRankingChangedStores };
